import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

const UnlockPage = () => {
    const [key, setKey] = useState("");
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // 🚀 Redirect if already unlocked
    useEffect(() => {
        if (localStorage.getItem("unlocked") === "true") {
            navigate("/home");
        }
    }, [navigate]);

    const handleUnlock = async () => {
        if (!key.trim()) {
            setError("Key is required.");
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/unlock`, { key });
            if (response.data.message === "Access granted") {
                localStorage.setItem("unlocked", "true");
                setTimeout(() => navigate("/home"), 1200);
            } else {
                setError("Invalid key. Try again.");
            }
        } catch (error) {
            setError("Invalid key. Try again.");
            setIsLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-black px-4 sm:px-0">
            {/* Glassmorphism Card */}
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="glass w-full max-w-xs sm:max-w-sm p-6 sm:p-8 text-center border border-rose-300 bg-opacity-10 backdrop-blur-lg rounded-lg shadow-lg"
            >
                {/* Title */}
                <motion.h2
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    className="text-2xl sm:text-3xl font-bold text-rose-300 mb-6 tracking-wide"
                >
                    Enter Access Key
                </motion.h2>

                {/* Input Field */}
                <motion.input
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                    type="text"
                    placeholder="Enter key"
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                    className="input-field"
                />

                {/* Error Message */}
                {error && (
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        className="text-red-500 text-sm mt-3"
                    >
                        {error}
                    </motion.p>
                )}

                {/* Unlock Button */}
                <motion.button
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                    onClick={handleUnlock}
                    disabled={isLoading}
                    className={`w-full px-4 py-3 text-lg btn btn-primary mt-6 
                        ${isLoading ? "opacity-70 cursor-not-allowed" : "hover:scale-105"
                        }`}
                >
                    {isLoading ? "Accessing..." : "Access"}
                </motion.button>
            </motion.div>
        </div>
    );
};

export default UnlockPage;
